<template>
    <Loops
        ref="inner"
        v-bind="$props"
        @onCenterChart="handleOnCenterChart"
        @onRequestModelInfo="handleOnRequestModelInfo"
        @onLoadChart="handleOnLoadChart"
        @onReset="handleOnReset"
        @variantsLoading="handleVariantsLoading"
        @onOpenRenameLoopModal="handleOnOpenRenameLoopModal"
    />
</template>

<script>
import VueTypes from 'vue-types'
import Loops from '../Loops/Loops.vue'

export default {
    name: 'ProcessLoopsDrawerPanel',
    components: { Loops },
    inheritAttrs: false,
    props: {
        value: VueTypes.object,
        processId: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
        info: VueTypes.object,
        percentageMode: VueTypes.string,
        disableElements: VueTypes.bool,
    },
    methods: {
        initialize() {
            this.initializeLoops()
        },
        initializeLoops() {
            this.$refs.inner?.initializeLoops?.()
        },
        renameLoop(payload) {
            this.$refs.inner?.renameLoop?.(payload)
        },

        handleOnCenterChart(payload) {
            this.$emit('on-center-chart', payload)
        },
        handleOnRequestModelInfo(payload) {
            this.$emit('on-request-model-info', payload)
        },
        handleOnLoadChart(payload) {
            this.$emit('on-load-chart', payload)

            if (payload && (payload.variants || payload.variantId || payload.loopId || payload.loopId === 0)) {
                const requestPayload = {
                    variants: payload.variants,
                    variantId: payload.variantId,
                    loopId: payload.loopId,
                }
                this.$emit('on-request-model-info', requestPayload)
            }
        },
        handleOnReset(payload) {
            this.$emit('on-reset', payload)
        },
        handleVariantsLoading(payload) {
            this.$emit('variants-loading', payload)
        },
        handleOnOpenRenameLoopModal(payload) {
            this.$emit('on-open-rename-loop-modal', payload)
        },
    },
}
</script>
